import { render, staticRenderFns } from "./table-quarternary.vue?vue&type=template&id=362c770e&scoped=true&"
import script from "./table-quarternary.vue?vue&type=script&lang=js&"
export * from "./table-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362c770e",
  null
  
)

export default component.exports